module.exports = __webpack_public_path__ + "img/kt1.68f9c98d.png";